export default __webpack_public_path__ + "static/media/avatar.f890e459.png";